window.globalHelpersModule.directive "canceledCancellationApproved", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService',
($rootScope, $log, $timeout, $filter, $state, AuthService) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/feed-items/canceled_cancellation_approved/canceled_cancellation_approved-directive-template.html'
]